import React from 'react';
import {useNavigate} from 'react-router-dom';
import {FaChartBar} from 'react-icons/fa';
import {RoleTile} from './RoleShell';
export default function ActividadTile(){const navigate=useNavigate();return <RoleTile icon={FaChartBar} label="Mi actividad" description="Consulta tus reservas, entradas y comisiones." onClick={()=>navigate('/dashboard/actividad')}/>;}
